import { z } from 'zod';
import { addressSchema, contactSchema } from './companySchema';

/**
 * Branch Validation Schemas
 */

// Basic branch info
export const branchBasicSchema = z.object({
  name: z
    .string()
    .min(2, 'Branch name must be at least 2 characters')
    .max(200, 'Branch name must be less than 200 characters'),
});

// Infrastructure schema
export const infrastructureSchema = z.object({
  hasFirewall: z.boolean().default(false),
  numberOfUsers: z
    .union([z.string(), z.number()])
    .transform((val) => (typeof val === 'string' ? parseInt(val, 10) || 0 : val))
    .pipe(z.number().int().min(0, 'Cannot be negative'))
    .default(0),
  numberOfDevices: z
    .union([z.string(), z.number()])
    .transform((val) => (typeof val === 'string' ? parseInt(val, 10) || 0 : val))
    .pipe(z.number().int().min(0, 'Cannot be negative'))
    .default(0),
  numberOfNetworkDevices: z
    .union([z.string(), z.number()])
    .transform((val) => (typeof val === 'string' ? parseInt(val, 10) || 0 : val))
    .pipe(z.number().int().min(0, 'Cannot be negative'))
    .default(0),
  numberOfServers: z
    .union([z.string(), z.number()])
    .transform((val) => (typeof val === 'string' ? parseInt(val, 10) || 0 : val))
    .pipe(z.number().int().min(0, 'Cannot be negative'))
    .default(0),
});

// Full branch schema for wizard form
export const branchFormSchema = branchBasicSchema
  .merge(addressSchema)
  .merge(contactSchema)
  .merge(infrastructureSchema);

// Firewall schema
export const firewallSchema = z.object({
  firewallName: z
    .string()
    .min(1, 'Firewall name is required')
    .max(100, 'Firewall name must be less than 100 characters'),
  firewallBrand: z
    .string()
    .min(1, 'Firewall brand is required')
    .max(100, 'Firewall brand must be less than 100 characters'),
  firewallIP: z
    .string()
    .min(1, 'Firewall IP is required')
    .regex(
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      'Please enter a valid IP address'
    ),
  firewallUsername: z
    .string()
    .min(1, 'Firewall username is required')
    .max(100, 'Username must be less than 100 characters'),
  firewallPassword: z
    .string()
    .min(1, 'Firewall password is required')
    .max(200, 'Password must be less than 200 characters'),
  firewallAgentInstalled: z.boolean().default(false),
  oldAdminRemoved: z.enum(['Yes', 'No', 'N/A']).default('No'),
  firewallNotes: z.string().optional().or(z.literal('')),
});

export default branchFormSchema;

